const materialGroups = {
  pulse: {
    'patch-cord': {
      default: 2,
      fiberCount: {
        '1': 3,
        '2': 4,
        '2x1': 4
      }
    },
    'breakout': {
      default: 7,
    },
    'trunk': {
      default: 6,
      datacenter: {
        true: 9,
        false: 8
      }
    }
  }
}

export function getMaterialGroup({ route, isDatacenterMode, fiberCount }) {
  let defaultPerRoute = materialGroups.pulse[route].default

  let specializedMaterialGroup = null

  switch(route){
    case 'patch-cord':
      specializedMaterialGroup = materialGroups.pulse[route].fiberCount[fiberCount]
      break
    case 'trunk':
      specializedMaterialGroup = materialGroups.pulse[route].datacenter[isDatacenterMode.toString()]
      break
    case 'breakout':
      specializedMaterialGroup = materialGroups.pulse.breakout.default
      break
    default: 
      // new Error(`Materialgroup for ${route} and ${fiberCount} with datacenter = ${datacenter} not found`)
      break
  }

  return specializedMaterialGroup || defaultPerRoute
}